// removed by extract-text-webpack-plugin
module.exports = {"button":"button__jQNF7"};


//////////////////
// WEBPACK FOOTER
// ./components/button/style.css
// module id = +eY/
// module chunks = 3